// Query per l'aggiornamento di una regola

import type { AxiosError } from "axios";
import { createMutation, createQuery } from "react-query-kit";
import auth from "../../common/client";


type Variables = {
    data:any;
    id: number;
  };

export const updateRegola = createMutation<void ,Variables, AxiosError>({
    mutationFn: async ({ variables }) => {
        return auth?.post(`/api/updateRegola`,{...variables.data, assenza_id: variables.id}).then((response) => response.data).catch((err) => console.log(err));
    }
});



